import React from 'react';

interface VenereBoxProps {
  children: React.ReactNode;
  variant?: 'skin' | 'seasalt' | 'lavender' | 'matcha' | 'sky';
  className?: string;
  onClick?: () => void;
  interactive?: boolean;
  noPadding?: boolean;
}

export const VenereBox: React.FC<VenereBoxProps> = ({
  children,
  variant = 'skin',
  className = '',
  onClick,
  interactive = false,
  noPadding = false,
}) => {
  const baseClasses = `rounded-[20px] shadow-md transition-all duration-200 ${noPadding ? '' : 'p-[10px]'}`;
  
  const variantClasses = {
    skin: 'venere-bg-skin',
    seasalt: 'venere-bg-seasalt',
    lavender: 'venere-bg-lavender',
    matcha: 'venere-bg-matcha',
    sky: 'venere-bg-sky',
  };

  const interactiveClasses = interactive || onClick ? 'cursor-pointer hover:opacity-80' : '';

  return (
    <div
      className={`${baseClasses} ${variantClasses[variant]} ${interactiveClasses} ${className}`}
      onClick={onClick}
    >
      <div className="flex flex-col h-full w-full items-start">
        {children}
      </div>
    </div>
  );
};

export default VenereBox; 